var $ada895206b7edc18$exports = {};
$ada895206b7edc18$exports = {
    "info": `\u{8CC7}\u{8A0A}`,
    "negative": `\u{932F}\u{8AA4}`,
    "notice": `\u{8B66}\u{544A}`,
    "positive": `\u{6210}\u{529F}`
};


export {$ada895206b7edc18$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
